import useActiveEpisode from './useActiveEpisode';
import useLiveAudioSeek from './useLiveAudioSeek';
import { getTimeFromSeconds } from '@/helpers/math';

const useAudioTimes = () => {
  const { liveSeek } = useLiveAudioSeek();
  const { episode } = useActiveEpisode();

  const duration = episode?.duration || 0;

  const times = {
    current: getTimeFromSeconds(liveSeek)?.timeString,
    remaining: getTimeFromSeconds(duration - liveSeek)?.timeString,
    max: getTimeFromSeconds(duration)?.timeString,
    raw: {
      current: liveSeek,
      max: duration
    }
  };

  return times;
};

export default useAudioTimes;